export const RISK_WARNING_INDEX = 3;
